import React from 'react'
import { MessageBar, MessageBarType } from '@fluentui/react';
import { useTranslation } from "react-i18next";

function Message(props) {
    const { t } = useTranslation();

    //Parametros de entrada.
    const inputParam_Message = props.message !== undefined && props.message !== null ? props.message : null;
    const inputParam_MessageType = props.messageType;
    const inputParam_Display = props.display;
    const inputParam_SetterShowMessage = props.setterShowMessage;
    const inputParam_Width = props.width !== undefined && props.width !== null ? props.width : "100%";

    //Parametros de componente.

    //Funciones de componente.

    //Eventos de componente.
    const onCloseSuccessMessageBar = () => {
        inputParam_SetterShowMessage(null);
    }
    //Render de componente.
    return (
        <div style={ { width: inputParam_Width, display: `${inputParam_Display ? "inline-block" : "none"}` } }>
            <MessageBar                
                dismissButtonAriaLabel={ t('data-lang-lbl-close') }
                messageBarType={ inputParam_MessageType === "success" ? MessageBarType.success : (inputParam_MessageType === "error" ? MessageBarType.error : (inputParam_MessageType === "warning" ? MessageBarType.warning : MessageBarType.info)) }
                onDismiss={ ()=> onCloseSuccessMessageBar() }>
                { inputParam_Message !== null ? inputParam_Message.indexOf('data-lang-') !== -1 ? t(inputParam_Message) : inputParam_Message : "" }
            </MessageBar>
        </div>
    );
}

export default Message;